import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import { StyledComplexChipBaseWrapper } from "app/pages/sales-intelligence/common-components/filters-panel/components/FiltersComplexChip/styles";

export const StyledVisitsFromResultContainer = styled(Stack)`
    gap: 4px;
    padding: 8px;
    border-radius: 8px;
    background: ${colorsPalettes.bluegrey[100]};
`;

export const StyledChipContainer = styled(StyledComplexChipBaseWrapper)`
    background: ${colorsPalettes.bluegrey[100]};
`;
